import moment from 'moment';
import * as he from 'he';

export const decodeText = (text) => {
  let fixedText = text;
  if (text) {
    fixedText = he.decode(text);
    fixedText = fixedText.replace(/“|”/g, '"');
    fixedText = fixedText.replace(/‘|’/g, '\'');
  }

  return fixedText;
}

export const convertTextToEscapedHTML = (text) => {
  const div = document.createElement('div')
  div.textContent = text
  return div.innerHTML
}

export const isEscapedTextLengthGreaterThanMaxLength = (text, maxLength) => {
  var isTitleTooLong = false;
  if (text) {
    const escapedTextLength = convertTextToEscapedHTML(text).length
      if (escapedTextLength > maxLength) {
          isTitleTooLong = true
      }
  }
  return isTitleTooLong
}
export const truncateTextIfMaxEscapedLengthExceeded = (text, maxLength) => {
  if (text) {
    var escapedText = convertTextToEscapedHTML(text)
    const escapedTextLength = escapedText.length
    if(escapedTextLength > maxLength){
      escapedText = escapedText.substring(0, maxLength)
    }
  }
  return escapedText
}

export const removeHtmlTags = (text) => {
  return text ? text.replace(/<\/?[^>]+>/ig, '') : text;
};

export const getTruncatedText = (text, maxChars) => {
  return (text && text.length > maxChars) ? text.substring(0, maxChars - 1) + "..." : text;
};

export const isStringNullOrEmpty = (str) => {
  return (!str || str.length === 0);
};

export const isNumberNullOrZero = (number) => {
  return (!number || number === 0 || parseInt(number) === 0);
};

export const isNumberNullOrNaN = (number) => {
  return (!number || parseInt(number) === 'NaN');
};

export const isNullOrEmptyGuid = (guid) => {
  return (!guid || guid === "00000000-0000-0000-0000-000000000000");
};

export const isGuid = (guid) => {
  let s = "" + guid;
  s = s.match('^(\{){0,1}[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}(\}){0,1}$');
  if (s === null) {
    return false;
  }

  return true;
}

export const isNullOrEmptyString = (str) => {
  return (!str || str === "");
};

export const isJsonString = (json) => {
  try {
    var str = JSON.stringify(json);
    JSON.parse(str);
  }
  catch (e) {
    return false;
  }

  return true;
}

export const getSafeLocaleString = (number) => {
  return number ? number.toLocaleString() : number;
};

export const getUserInitials = (fullName) => {
  if (!fullName)
    return "";

  var splitChar = fullName.indexOf('@') > 0 ? '@' : ' ';
  var names = fullName.split(splitChar),
    initials = names[0].substring(0, 1).toUpperCase();

  if (names.length > 1) {
    initials += names[names.length - 1].substring(0, 1).toUpperCase();
  }

  return initials;
}

export const getParticipantName = (participant) => {
  var name = participant ? participant.employeeName || participant.userEmailAddress || "" : "";
  if (name.indexOf('Participant') > -1 && name.indexOf('@') === -1) {
    let parts = name.split(' ');
    name = parts[0] + " " + parseInt(parts[1]);
  }

  return name;
}


export const getQuestionCount = (configuration, visibleOnly = false, includeNonQuestions = false) => {
  let count = 0;

  //BUG: we cannot use model.getAllQuestions() because it doesn't work with custom widgets!!
  if (configuration) {
    let surveyJson = JSON.parse(configuration);
    if (surveyJson && surveyJson.pages) {
      surveyJson.pages.forEach((page) => {
        if (page && page.elements) {
          page.elements.forEach((element) => {
            if (!visibleOnly || (visibleOnly && !element.visibleIf)) {
              if (includeNonQuestions) {
                count += 1;
              }
              else {
                count += (element.type === "sectionheader" || element.type === "paragraph" || element.type === "video") ? 0 : 1;
              }
            }
          });
        }
      });
    }
  }

  return count;
}

export const getAnswerCount = (resultData) => {
  let answerCount = 0;

  // never count an 'other' item or comment since it'll already be part of another question
  if (resultData) {
    let objectKeys = Object.keys(resultData);
    if (objectKeys) {
      objectKeys.forEach((key, index) => {
        if (key.indexOf("-Comment") <= 0 && key.indexOf("-UserComment") <= 0) {
          answerCount++;
        }
      });
    }
  }

  return answerCount;
}

export const getUnansweredCount = (formInstance) => {
  let unansweredCount = 0;
  if (formInstance) {
    unansweredCount = formInstance.questionCount - formInstance.answerCount;
  }

  return unansweredCount;
}

export const getToggledNavigationUrl = (oldUrl, newUrl) => {
  return newUrl;
}

export const delay = (ms) => {
  return new Promise(resolve => setTimeout(() => resolve(true), ms));
}

export const isOnlyActiveStatusFilterEnabled = (activeFilters) => {
  let isOnlyActiveStatusFilter = false;
  if (activeFilters && activeFilters.length > 0) {
    let statusFilterIndex = activeFilters.findIndex(af => af.key === "statusCode");
    if (statusFilterIndex >= 0) {
      let statusFilters = activeFilters[statusFilterIndex].values;
      isOnlyActiveStatusFilter = (statusFilters.length === 1 && statusFilters[0].value === "A");
    }
  }
  return isOnlyActiveStatusFilter;
}

export const getMomentFromDateTimeStrings = (date, time) => {
  let retMoment = moment(date);

  if (time && time.length > 0) {
    let parts = time.split(/[\s: ]+/);
    let hours = parts.length > 0 ? parseInt(parts[0].trim()) : 0;
    let mins = parts.length > 1 ? parseInt(parts[1].trim()) : 0;
    let ampm = parts.length > 2 ? parts[2].trim() : '';
    //let tz = parts.length > 3 ? parts[3].trim() : '';

    if (ampm.toUpperCase() === "PM") {
      hours += 12;
    }

    retMoment.add(hours, "hour");
    retMoment.add(mins, "minute");
  }

  return retMoment;
}

export const getPublicAccessToken = (companyId, itemGuid) => {
  var encodedString = btoa(`${companyId}-${itemGuid}`);
  return encodedString;
};

export const getFormattedUrl = (url) => {
  if (!url) return url;

  url = url.trim();
  if (url.substr(-1) != '/') {
    url += '/';
  }

  return url;
};

